import core from "@/helpers/client";
const unitService = {
  async headUnitMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/units`,
      params
    );
    return result;
  },
  async getUnitMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/units`,
      params
    );
    return result;
  },
  async getUnitMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/units/${id}`
    );
    return result;
  },
  async getUnitProductSkuListAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/units/${id}/skus`
    );
    return result;
  },
  async createUnitMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/units`,
      model
    );
    return result;
  },
  async updateUnitMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/units/${id}`,
      model
    );
    return result;
  }, 
  async UpdateAllUnitApprovalAsync(id, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/units/${id}/approval`,
      model
    );
    return result;
  },
  async deleteUnitMasterByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/units/delete/${id}`
    );
    return result;
  },
};
export default unitService;
